<ng-template #loader>
  <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
</ng-template>

<ng-template #operatingAirlineNotification let-operatingAirlineIdInfo="operatingAirlineIdInfo">
  <fcom-notification
    data-testid="operating-airline-notification"
    class="ms-small-t"
    [title]="
      (operatingAirlineIdInfo.isOrder
        ? 'ancillaries.seat.operatingAirlineNotification.header.mmb'
        : 'ancillaries.seat.operatingAirlineNotification.header.booking'
      ) | finLocalization
    "
  >
    <span data-testid="operating-airline-notification-message" class="font-body-1 ps-small-b wrap">{{
      (operatingAirlineIdInfo.isOrder
        ? 'ancillaries.seat.operatingAirlineNotification.generalMessage.mmb'
        : 'ancillaries.seat.operatingAirlineNotification.generalMessage.booking'
      ) | finLocalization
    }}</span>
    <span
      *ngIf="operatingAirlineIdInfo.isOrder"
      data-testid="operating-airline-notification-pnr-message"
      class="font-body-1 ps-small-b"
    >
      {{
        (operatingAirlineIdInfo.isOrderIdIdentical
          ? 'ancillaries.seat.operatingAirlineNotification.pnrMessage.sameId'
          : 'ancillaries.seat.operatingAirlineNotification.pnrMessage.differentId'
        ) | finLocalization
      }}
      <span class="bold-type">
        {{ operatingAirlineIdInfo.operatingAirlineId.id }}
      </span>
    </span>
  </fcom-notification>
</ng-template>

<button id="seatMapStart" (click)="moveFocus($event, 'seatMapEnd')" class="is-vishidden">
  {{ 'ancillaries.seats.skipSeatSelection' | finLocalization }}
</button>

<div class="inline-block valign-top fill" [attr.data-flight-id]="flight.id">
  <ng-container *ngIf="notEligibleWhenCheckInClosed">
    <fcom-notification
      data-testid="seat-map-not-available-after-check-in-notification"
      class="block ps-small-y ps-small-t"
      [theme]="NotificationTheme.INFO"
    >
      {{ 'services.seat.notAvailableWhenCheckInClosed' | finLocalization }}
    </fcom-notification>
  </ng-container>
  <ng-container *ngIf="!notEligibleWhenCheckInClosed">
    <ng-container
      *ngIf="
        ((flight.seatMapStatus$ | async) === SeatMapStatus.OK && (selectablePassengers$ | async)?.length) ||
          (flight.seatMapStatus$ | async) === SeatMapStatus.OK_NO_AVAILABILITY ||
          (flight.seatMapStatus$ | async) === SeatMapStatus.LOAD_ERROR;
        else loader
      "
    >
      <div
        *ngIf="(flight.seatMapStatus$ | async) === SeatMapStatus.LOAD_ERROR"
        class="error-seatmap ps-medium align-center"
      >
        <fcom-icon
          [attr.aria-label]="'ancillaries.seats.alert' | finLocalization"
          class="ms-xsmall-l ps-small-b icon-xlarge"
          [name]="SvgLibraryIcon.ALERT_TRIANGLE"
        ></fcom-icon>
        <h4 class="ps-medium-y">
          {{ 'ancillaries.seats.loadErrorTitle' | finLocalization }}
        </h4>
        <p>{{ 'ancillaries.seats.loadErrorContent' | finLocalization }}</p>
        <fcom-button
          class="retry-button ps-large-t"
          [text]="'ancillaries.seats.retry' | finLocalization"
          (clickBtn)="retrySeatmap.emit(flight)"
        ></fcom-button>
      </div>
      <ng-container *ngIf="(flight.seatMapStatus$ | async) === SeatMapStatus.OK_NO_AVAILABILITY">
        <div class="unavailable-seatmap ps-medium flex flex--column flex--center" data-testid="unavailable-seatmap">
          <div
            [attr.aria-label]="'bookingSummary.operatedBy' | finLocalization"
            class="ms-medium-b airline-tail {{ currentFlightTail }}"
          ></div>
          <ng-container *ngIf="noSeatmapNotifications$ | async as notifications">
            <ng-container *ngFor="let notification of notifications">
              <h4
                class="ps-medium-b align-center"
                *ngIf="notification.key | finHasLocalizationKey; else fallbackNotification"
              >
                {{ notification.key | finLocalization }}
              </h4>
              <p *ngIf="notification.reason">
                {{ notification.reason.key | finLocalization: notification.reason.data }}
              </p>
            </ng-container>
          </ng-container>
          <ng-template #fallbackNotification>
            <h4 class="ps-medium-b align-center">
              {{ 'services.cannotAdd' | finLocalization }}
            </h4>
          </ng-template>
        </div>
        @if ((operatingAirlineIdInfo$ | async)?.isOperated) {
          <ng-container
            *ngTemplateOutlet="
              operatingAirlineNotification;
              context: { operatingAirlineIdInfo: operatingAirlineIdInfo$ | async }
            "
          />
        }
      </ng-container>
      <ng-container *ngIf="(flight.seatMapStatus$ | async) === SeatMapStatus.OK">
        <fcom-notification
          *ngIf="unmodifiableSeat$ | async"
          [iconName]="SvgLibraryIcon.CHECKMARK"
          class="notification pr-small-b"
        >
          {{ 'MMB.view.seatMap.paidSeatNotification' | finLocalization }}
        </fcom-notification>
        <fcom-notification
          *ngIf="unmodifiableFreeSeat$ | async"
          [iconName]="SvgLibraryIcon.CHECKMARK"
          class="notification pr-small-b"
        >
          {{ 'MMB.view.seatMap.ticketedSeatNotification' | finLocalization }}
        </fcom-notification>

        <fin-seat-passengers
          [passengers$]="selectablePassengers$"
          [flight]="flight"
          [includedSeats]="includedSeats"
          (selectPax)="selectPassenger($event)"
          (clearSeatSelection)="selectSeat($event)"
        ></fin-seat-passengers>

        @if (bundlesEnabled) {
          <fin-seat-bundle-toggle
            [discountPercentage]="'10'"
            [active]="bundleActive$ | async"
            (bundleToggled)="onBundleToggle($event)"
          ></fin-seat-bundle-toggle>
        }

        @if (benefitTextKey) {
          <fin-seat-benefit [descriptionKey]="benefitTextKey" [tag]="benefitTag"></fin-seat-benefit>
        }

        <fin-seat-map-seatchips
          *ngIf="seatMapElement?.seatMapWrapper"
          [flight]="flight"
          [passengers$]="selectablePassengers$"
          [seatMapElement]="seatMapElement.seatMapWrapper"
          (scrollToSeat)="scrollToSeat($event)"
        ></fin-seat-map-seatchips>

        <div class="relative">
          <fcom-icon-button
            data-testid="carousel-prev"
            class="control prev absolute ms-xsmall-l"
            [disabled]="isAtStart"
            [icon]="{ name: SvgLibraryIcon.ARROW_LEFT }"
            [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
            [size]="IconButtonSize.LARGE"
            [aria]="{ label: 'carousel.previous' | finLocalization }"
            (clickBtn)="scrollSeatMap('right')"
          >
          </fcom-icon-button>
          <fin-seat-map-renderer
            #seatMap
            [flight]="flight"
            [passengers$]="selectablePassengers$"
            [unavailableSeatLabel]="'seatMap.seats.unavailable' | finLocalization"
            [includedSeats]="includedSeats"
            (updatePosition)="enableScrollButtons($event)"
            (selectSeat)="selectSeat($event)"
            (updateScrollPosition)="scrollPosition = $event"
          ></fin-seat-map-renderer>
          <fcom-icon-button
            data-testid="carousel-next"
            class="control next absolute ms-xsmall-r"
            [disabled]="isAtEnd"
            [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT }"
            [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
            [size]="IconButtonSize.LARGE"
            [aria]="{ label: 'carousel.next' | finLocalization }"
            (clickBtn)="scrollSeatMap('left')"
          >
          </fcom-icon-button>
        </div>

        <div class="mr-small-t ps-small-y mini-map-wrapper">
          <fin-seat-map-mini-map
            *ngIf="(flight.seatMapStatus$ | async) === SeatMapStatus.OK && (seatMapContainerWidth$ | async)"
            [flight]="flight"
            [viewPortWidth$]="seatMapContainerWidth$"
            [scrollPosition]="scrollPosition"
            (scrollTo)="scrollTo($event)"
            (keyScrollDirection)="scrollSeatMap($event)"
          ></fin-seat-map-mini-map>
        </div>

        <div class="flex flex--column flex--center mr-xsmall-y">
          <h5>{{ 'seatMap.airCraftModel' | finLocalization }}</h5>
          <span class="font-body-1" *ngIf="isFinnairWetLease">
            {{ flight.aircraft.name }}
          </span>
          <span *ngIf="!isFinnairWetLease" class="font-body-1 flex flex--center ps-xxsmall" id="aircraft-read-more"
            >{{ 'aircrafts.' + flight.aircraft.code | finLocalization }} ({{ flight.aircraft.code }})
            <fcom-icon-button
              class="flex flex--self-center ps-xxsmall ms-xxsmall-l"
              [icon]="{ name: SvgLibraryIcon.INFO }"
              [theme]="IconButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
              [size]="IconButtonSize.SMALL"
              [aria]="{ label: 'readMore' | finLocalization }"
              aria-labelledby="aircraft-read-more"
              (clickBtn)="openAirplaneModal()"
            >
            </fcom-icon-button>
          </span>
        </div>
      </ng-container>

      <fin-multi-city-survey class="block mr-small-b"></fin-multi-city-survey>
    </ng-container>
  </ng-container>
</div>

<button id="seatMapEnd" (click)="moveFocus($event, 'seatMapStart')" class="is-vishidden">
  {{ 'ancillaries.seats.backToSeatMap' | finLocalization }}
</button>

<fcom-modal
  [(open)]="exitRowModalOpen"
  [title]="'ancillaries.seats.popover.confirmExitRowTitle' | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
>
  <div class="pr-large-x pr-medium-y block wrap">
    <fin-seat-details [seatDetails$]="seatDetails$" [hideButtons]="true"></fin-seat-details>
  </div>
  <div buttons *ngIf="seatDetails$ | async as seatDetails">
    <fcom-button
      class="mr-xsmall-r"
      data-testid="cancel-selection-button"
      [text]="'actions.cancel' | finLocalization"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [aria]="{ label: 'actions.cancel' | finLocalization, role: 'button' }"
      (clickBtn)="exitRowModalOpen = false"
    ></fcom-button>
    <fcom-button
      data-testid="confirm-selection-button"
      [text]="'ancillaries.seats.popover.confirmExitRowAction' | finLocalization"
      [aria]="{ label: 'ancillaries.seats.popover.confirmExitRowAction' | finLocalization, role: 'button' }"
      (clickBtn)="confirmExitRowSeat(seatDetails.travelerId, seatDetails.seatNumber)"
    ></fcom-button>
  </div>
</fcom-modal>

<fcom-modal [(open)]="aircraftModalOpen" [title]="flight.aircraft.name" *ngIf="aircraftInformationTemplate$ | async">
  <div class="wrap pr-large-x">
    <fin-cms-json-content [template$]="aircraftInformationTemplate$"></fin-cms-json-content>
  </div>
</fcom-modal>
